import env from '../../core/config/env'

export const Privacy = () => {
  return (
    <main>
      <h1>Política de Privacidade</h1>

      <p>
        A sua privacidade é importante para nós. É política da Celetus respeitar
        a sua privacidade em relação a qualquer informação sua que possamos
        coletar no site Celetus, e outros sites que possuímos e operamos.
      </p>

      <p>
        Solicitamos informações pessoais apenas quando realmente precisamos
        delas para lhe fornecer um serviço. Fazemo-lo por meios justos e legais,
        com o seu conhecimento e consentimento. Também informamos por que
        estamos coletando e como será usado.
      </p>

      <p>
        Apenas retemos as informações coletadas pelo tempo necessário para
        fornecer o serviço solicitado. Quando armazenamos dados, protegemos
        dentro de meios comercialmente aceitáveis para evitar perdas e roubos,
        bem como acesso, divulgação, cópia, uso ou modificação não autorizados.
      </p>

      <p>
        Não compartilhamos informações de identificação pessoal de Produtores
        cadastrados na plataforma, exceto quando exigido por lei, ordem
        judicial, ou a pedido de Comprador para fins de identificação de quem
        vendeu-lhe o respectivo infoproduto, ou de pessoa legitimamente
        interessada.
      </p>

      <p>
        O nosso site pode ter links para sites externos que não são operados por
        nós. Esteja ciente de que não temos controle sobre o conteúdo e práticas
        desses sites e não podemos aceitar responsabilidade por suas respectivas
        políticas de privacidade.
      </p>

      <p>
        Você é livre para recusar a nossa solicitação de informações pessoais,
        entendendo que talvez não possamos fornecer alguns dos serviços
        desejados.
      </p>

      <p>
        O uso continuado de nosso site será considerado como aceitação de nossas
        práticas em torno de privacidade e informações pessoais. Se você tiver
        alguma dúvida sobre como lidamos com dados do usuário e informações
        pessoais, entre em contacto conosco.
      </p>

      <h2>Política de Cookies Celetus</h2>

      <h3>O que são cookies?</h3>
      <p>
        Como é prática comum em quase todos os sites profissionais, este site
        usa cookies, que são pequenos arquivos baixados no seu computador, para
        melhorar sua experiência. Esta página descreve quais informações eles
        coletam, como as usamos e por que às vezes precisamos armazenar esses
        cookies. Também compartilharemos como você pode impedir que esses
        cookies sejam armazenados, no entanto, isso pode fazer o downgrade ou
        “quebrar” certos elementos da funcionalidade do site.
      </p>

      <h3>Como usamos os cookies?</h3>
      <p>
        Utilizamos cookies por vários motivos, detalhados abaixo. Infelizmente,
        na maioria dos casos, não existem opções padrão do setor para desativar
        os cookies sem desativar completamente a funcionalidade e os recursos
        que eles adicionam a este site. É recomendável que você deixe todos os
        cookies se não tiver certeza se precisa ou não deles, caso sejam usados
        para fornecer um serviço que você usa.
      </p>

      <h3>Desativar cookies</h3>
      <p>
        Você pode impedir a configuração de cookies ajustando as configurações
        do seu navegador (consulte a Ajuda do navegador para saber como fazer
        isso). Esteja ciente de que a desativação de cookies afetará a
        funcionalidade deste e de muitos outros sites que você visita. A
        desativação de cookies geralmente resultará na desativação de
        determinadas funcionalidades e recursos deste site. Portanto, é
        recomendável que você não desative os cookies.
      </p>

      <h3>Cookies que definimos</h3>

      <h4>Cookies relacionados à conta</h4>
      <p>
        Se você criar uma conta conosco, usaremos cookies para o gerenciamento
        do processo de inscrição e administração geral. Esses cookies geralmente
        serão excluídos quando você sair do sistema, porém, em alguns casos,
        eles poderão permanecer posteriormente para lembrar as preferências do
        seu site ao sair.
      </p>

      <h4>Cookies relacionados ao login</h4>
      <p>
        Utilizamos cookies quando você está logado, para que possamos lembrar
        dessa ação. Isso evita que você precise fazer login sempre que visitar
        uma nova página. Esses cookies são normalmente removidos ou limpos
        quando você efetua logout para garantir que você possa acessar apenas
        recursos e áreas restritas ao efetuar login.
      </p>

      <h4>Cookies relacionados a boletins por e-mail</h4>
      <p>
        Este site oferece serviços de assinatura de boletim informativo ou
        e-mail, e os cookies podem ser usados para lembrar se você já está
        registrado e se deve mostrar determinadas notificações válidas apenas
        para usuários inscritos ou não inscritos.
      </p>

      <h4>Pedidos processando cookies relacionados</h4>
      <p>
        Este site oferece facilidades de comércio eletrônico ou pagamento, e
        alguns cookies são essenciais para garantir que seu pedido seja lembrado
        entre as páginas, para que possamos processá-lo adequadamente.
      </p>

      <h4>Cookies relacionados a pesquisas</h4>
      <p>
        Periodicamente, oferecemos pesquisas e questionários para fornecer
        informações interessantes, ferramentas úteis ou para entender nossa base
        de usuários com mais precisão. Essas pesquisas podem usar cookies para
        lembrar quem já participou de uma pesquisa ou para fornecer resultados
        precisos após a alteração das páginas.
      </p>

      <h4>Cookies relacionados a formulários</h4>
      <p>
        Quando você envia dados por meio de um formulário, como os encontrados
        nas páginas de contato ou nos formulários de comentários, os cookies
        podem ser configurados para lembrar os detalhes do usuário para
        correspondência futura.
      </p>

      <h4>Cookies de preferências do site</h4>
      <p>
        Para proporcionar uma ótima experiência neste site, fornecemos a
        funcionalidade para definir suas preferências de como esse site é
        executado quando você o usa. Para lembrar suas preferências, precisamos
        definir cookies para que essas informações possam ser chamadas sempre
        que você interagir com uma página afetada por suas preferências.
      </p>

      <h3>Cookies de Terceiros</h3>
      <p>
        Em alguns casos especiais, também usamos cookies fornecidos por
        terceiros confiáveis. A seguir, detalhamos quais cookies de terceiros
        você pode encontrar através deste site:
      </p>

      <h4>Google Analytics</h4>
      <p>
        Este site usa o Google Analytics, que é uma das soluções de análise mais
        difundidas e confiáveis da Web, para nos ajudar a entender como você usa
        o site e como podemos melhorar sua experiência. Esses cookies podem
        rastrear itens como quanto tempo você gasta no site e as páginas
        visitadas, para que possamos continuar produzindo conteúdo atraente.
        Para mais informações sobre cookies do Google Analytics, consulte a
        página oficial do Google Analytics.
      </p>

      <h4>Análises de terceiros</h4>
      <p>
        As análises de terceiros são usadas para rastrear e medir o uso deste
        site, para que possamos continuar produzindo conteúdo atrativo. Esses
        cookies podem rastrear itens como o tempo que você passa no site ou as
        páginas visitadas, o que nos ajuda a entender como podemos melhorar o
        site para você.
      </p>

      <h4>Testes de novos recursos</h4>
      <p>
        Periodicamente, testamos novos recursos e fazemos alterações sutis na
        maneira como o site se apresenta. Enquanto testamos novos recursos,
        esses cookies podem ser usados para garantir que você receba uma
        experiência consistente, enquanto entendemos quais otimizações nossos
        usuários mais apreciam.
      </p>

      <h4>Estatísticas de vendas</h4>
      <p>
        À medida que vendemos produtos, é importante entendermos as estatísticas
        sobre quantos visitantes de nosso site realmente compram. Esse é o tipo
        de dados que esses cookies rastrearão, permitindo-nos fazer previsões de
        negócios com precisão para analisar nossos custos de publicidade e
        produtos, garantindo o melhor preço possível.
      </p>

      <h3>Mais informações</h3>
      <p>
        Esperamos que esteja esclarecido. Se houver algo sobre o qual você tenha
        dúvidas, geralmente é mais seguro deixar os cookies ativados, caso
        interaja com um dos recursos que você usa em nosso site.
      </p>

      {env.SHOW_ASAAS_SEAL && (
        <p>
          A Celetus utiliza como meio de pagamento a solução da asaas.com como
          parceria.
        </p>
      )}

      <p>Esta política é efetiva a partir de novembro/2025.</p>

      <p>
        Para falar com a Data Protection Officer da Celetus, entre em contato
        através do e-mail <strong>email celetus</strong>.
      </p>
    </main>
  )
}
